<template>
  <div 
    v-if="currentCategory === 'all' || (currentCategory === game.category)"
    :class="game.category"
    class="game-item"
  >
    <div class="game-image">
      <img
        :src="thumbURL+game.img"
        class="rounded"
        style="width:254px;">
      <button 
        class="btn btn_config" 
        @click.prevent="openModal(game)">PLAY GAME</button>
    </div>
    <b>{{ game.name }}</b>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    name: "Game",
    props: {
      game: {
      	type: Object,
        required: true,
      },
    },
    data() {
      return {
        thumbURL: 'https://demo-uat.cbcontents.com/',
      }
    },
    computed: {
      ...mapGetters(['currentCategory', 'currentGame']),
    },
    methods: {
      openModal(game) {
      	this.$store.commit('SET_ACTIVE_GAME', game);
        this.$modal.show('configModal');
      },
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Game.vue